import React, {useEffect, useState} from "react";
import {observer} from "mobx-react";
import {ToggleSwitchComponent} from "../../../basic-ui-components/form/toggle-switch/toggle-switch.component";
import {useServices} from "../../../react-hooks/use-services.hook";
import {JackpotBetsOptStatusType} from "../../../services/jackpot-bet/jackpot-bets.service.interface";
import {CyClass} from "../../../../common/cy-classes";

export const JackpotBetsToggle: React.FC = observer(() => {
    const services = useServices();
    const [toggleStatus, setToggleStatus] = useState(JackpotBetsOptStatusType.Unknown);

    useEffect(() => {
        services.jackpotBet.getOptInStatus().then(status => {
            setToggleStatus(status);
        })
    }, [services.jackpotBet]);

    const onToggleHandler = async () => {
        if(toggleStatus === JackpotBetsOptStatusType.OptIn) {
            setToggleStatus(JackpotBetsOptStatusType.OptOut);
        } else  {
            setToggleStatus(JackpotBetsOptStatusType.OptIn);
        }
        try {
            await services.jackpotBet.toggleJackpotBet();
        } finally {
            setToggleStatus(await services.jackpotBet.getOptInStatus());
        }
    }

    return (
        <ToggleSwitchComponent checked={toggleStatus === JackpotBetsOptStatusType.OptIn} onToggle={onToggleHandler} className={CyClass('cy-jackpot-bets-toggle')}/>
    )
})